import requestFn, { baseUrl, objectToStringify } from './request';
const { post, get } = requestFn;
//get方式
export function fetchGet(url, params) {
    return get(`${baseUrl}${url}${objectToStringify(params)}`);
}
//post方式
export function fetchPost(url, params) {
    return post(`${baseUrl}${url}`, params);
}